import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
// eslint-disable-next-line
import { AnalyticsProviderSimplified as AnalyticsProvider, useConsoleAnalyticsHandler, useDatalayerAnalyticsHandler, AnalyticsHandlerRegistrantSimplified as AnalyticsHandlerRegistrant, useSegmentAnalyticsHandler, useDatalayerGa4AnalyticsHandler, NextJsPageViewTrackerSimplified as NextJsPageViewTracker } from '@scentregroup/analytics';
import { useSegmentConfiguration } from '../analytics-segment';
import { FeatureFlagName } from '../feature-flags';
import { localeToCountry } from '../helpers/local-to-country';
import useFeatureFlag from '../hooks/use-feature-flag';
import { useRouter } from '../next/router';
import { AnalyticsUserIdTracker } from '../analytics-helpers';
import { AnalyticsImpressionTrackerProvider } from '../analytics-observer/analytics-impression-tracker';
import { SentryAnalyticsHandler } from '../analytics-sentry';
import { transformObjectActionEvent } from '../analytics-datalayer/event-transformation';
import { transformLegacyEventForSegment } from '../analytics-segment/event-transformation';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RegisterHandlers = () => {
  const {
    locale
  } = useRouter();
  const country = localeToCountry(locale);
  const segmentConfiguration = useSegmentConfiguration(country);
  const enableAnalyticsConsole = useFeatureFlag(FeatureFlagName.NEXT_PUBLIC_FEAT_FLAG_ANALYTICS_CONSOLE);
  const datalayerAnalyticsHandler = useDatalayerAnalyticsHandler({
    transformObjectActionEvent
  });
  const consoleAnalyticsHandler = useConsoleAnalyticsHandler();
  // TODO If we start tracking non-page-views via the GA4 handler
  // and we need to convert legacy events, we will have to refactor
  // '../analytics-segment/event-transformation' to first transform
  // legacy events to object action events and pass that transform
  // in here.
  const datalayerGa4AnalyticsHandler = useDatalayerGa4AnalyticsHandler();
  const segmentHandlerArg = _objectSpread(_objectSpread({}, segmentConfiguration !== null && segmentConfiguration !== void 0 ? segmentConfiguration : {
    writeKey: null
  }), {}, {
    transformLegacyEventForSegment
  });
  const segmentAnalyticsHandler = useSegmentAnalyticsHandler(segmentHandlerArg);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(AnalyticsHandlerRegistrant, _objectSpread(_objectSpread({}, datalayerAnalyticsHandler), {}, {
      "data-id": "analytics_analytics-providers-and-init_RegisterHandlers_AnalyticsHandlerRegistrant"
    })), enableAnalyticsConsole && /*#__PURE__*/_jsx(AnalyticsHandlerRegistrant, _objectSpread(_objectSpread({}, consoleAnalyticsHandler), {}, {
      "data-id": "analytics_analytics-providers-and-init_RegisterHandlers_AnalyticsHandlerRegistrant_1"
    })), /*#__PURE__*/_jsx(AnalyticsHandlerRegistrant, _objectSpread(_objectSpread({}, datalayerGa4AnalyticsHandler), {}, {
      "data-id": "analytics_analytics-providers-and-init_RegisterHandlers_AnalyticsHandlerRegistrant_2"
    })), segmentConfiguration && /*#__PURE__*/_jsx(AnalyticsHandlerRegistrant, _objectSpread(_objectSpread({}, segmentAnalyticsHandler), {}, {
      "data-id": "analytics_analytics-providers-and-init_RegisterHandlers_AnalyticsHandlerRegistrant_3"
    })), /*#__PURE__*/_jsx(SentryAnalyticsHandler, {
      "data-id": "analytics_analytics-providers-and-init_RegisterHandlers_SentryAnalyticsHandler"
    })]
  });
};
const AnalyticsProvidersAndInit = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/_jsxs(AnalyticsProvider, {
    "data-id": "analytics_analytics-providers-and-init_RegisterHandlers_AnalyticsProvider",
    children: [/*#__PURE__*/_jsx(RegisterHandlers, {
      "data-id": "analytics_analytics-providers-and-init_AnalyticsProvider_RegisterHandlers"
    }), /*#__PURE__*/_jsx(NextJsPageViewTracker, {
      "data-id": "analytics_analytics-providers-and-init_RegisterHandlers_AnalyticsProvider_NextJsPageViewTracker"
    }), /*#__PURE__*/_jsx(AnalyticsUserIdTracker, {
      "data-id": "analytics_analytics-providers-and-init_RegisterHandlers_AnalyticsProvider_AnalyticsUserIdTracker"
    }), /*#__PURE__*/_jsx(AnalyticsImpressionTrackerProvider, {
      "data-id": "analytics_analytics-providers-and-init_RegisterHandlers_AnalyticsProvider_AnalyticsImpressionTrackerProvider",
      children: children
    })]
  });
};
export default AnalyticsProvidersAndInit;